import User from "@mapmycustomers/shared/types/User";
import { getAvatarSvg } from "@mapmycustomers/ui";

import { UserColorClassNameGetter } from "@app/store/userColor/selectors";
import colors from "@app/styles/_colors.module.scss";
import { USER_LOCATION_ZINDEX } from "@app/util/map/consts";
import isUserActive from "@app/util/map/isUserActive";
import svgToDataUrl from "@app/util/map/svgToDataUrl";

const SIZE = 28;

const getSingleUserLocationStyles = (
  user: User,
  selectedUser: undefined | User,
  getUserColorClassName: UserColorClassNameGetter,
  userIdToBase64Avatar: Map<User["id"], string>
): google.maps.Data.StyleOptions => {
  const avatarSvg = getAvatarSvg(
    {
      greyed: !isUserActive(user),
      size: SIZE,
      strokeColor: selectedUser?.id === user.id ? colors.primary100 : colors.white,
      user,
      userImageString: userIdToBase64Avatar?.get(user.id),
    },
    getUserColorClassName
  );

  const svg = `<svg width="${SIZE}" height="${SIZE}" viewBox="0 0 ${SIZE} ${SIZE}" fill="none" xmlns="http://www.w3.org/2000/svg">
      ${avatarSvg}
    </svg>
    `;

  return {
    icon: {
      anchor: new google.maps.Point(SIZE / 2, SIZE / 2),
      scaledSize: new google.maps.Size(SIZE, SIZE),
      url: svgToDataUrl(svg),
    },
    zIndex: USER_LOCATION_ZINDEX,
  };
};

export default getSingleUserLocationStyles;
